import type { IUser } from 'dromo-uploader-react';
import type { User } from './types';

export function convertUserToDromoUser(user: User): IUser {
  return {
    ...user,
    companyId: user.companyId.toString(),
    id: user.id.toString(),
  };
}
